export const FIELD_BORDER = 'rgba(70, 60, 50, 0.1)';
